<!--
 * @Author: pengyong
 * @Date: 2020-11-29 21:26:43
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-03 22:25:48
 * @Description:
 * @FilePath: /exhibit/src/views/exhibition/components/About.vue
-->
<template>
    <div class="about" v-on-clickaway="handleClose">
        <div class="title">{{ $t("exhibit").about }}</div>
        <div class="desc">
            XXXXXXXXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX，XXXXX
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {
        handleClose() {
            this.$emit("close");
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/var.scss";

.about {
    width: 668px;
    height: 320px;
    background: #ffffff;
    border-radius: 40px;
    padding: 25px 45px;
    position: absolute;
    top: -332px;
    right: 0;
    z-index: $zIndex-home-classify;
    .title {
        font-size: 23px;
        font-weight: 600;
        color: #09468c;
        line-height: 32px;
        height: 32px;
        margin-bottom: 56px;
    }
    .desc {
        font-size: 18px;
        font-weight: 600;
        color: #09468c;
        line-height: 25px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/components/About.vue